import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import OptionCalendarPage from "@/pages/admin/OptionCalendarPage";

export const Route = createFileRoute("/_admin/admin/option-calendar")({
  head: () => pageHead("Admin · Option Calendar", "AKIVA admin · option calendar portal.", "/admin/option-calendar", true),
  component: OptionCalendarPage,
});
